module.exports = __webpack_public_path__ + "static/img/qtcj05.258087b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qtcj05.png
// module id = 465
// module chunks = 0